(function () {
  if (window.mlAlternativeProductPopupInitialized) return;
  window.mlAlternativeProductPopupInitialized = true;

  var lastTriggerByDialog = new WeakMap();

  function pushDataLayer(eventName, root, extra) {
    if (!root) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName,
          source_product_id: root.dataset.productId || "",
          source_product_handle: root.dataset.productHandle || "",
          baseline_product_id: root.dataset.baselineProductId || "",
          baseline_product_handle: root.dataset.baselineProductHandle || "",
          alternative_count: Number(root.dataset.alternativeCount || 0),
        },
        extra || {}
      )
    );
  }


  function rememberChoice(root, link) {
    var payload = {
      source_product_id: root.dataset.productId || "",
      source_product_handle: root.dataset.productHandle || "",
      selected_product_id: link.dataset.selectedProductId || "",
      selected_product_handle: link.dataset.selectedProductHandle || "",
      selected_product_title: link.dataset.selectedProductTitle || "",
      option_position: Number(link.dataset.optionPosition || 0),
      selected_at: new Date().toISOString(),
    };

    try {
      sessionStorage.setItem("mlAlternativePopupChoice", JSON.stringify(payload));
      sessionStorage.setItem(
        "mlAlternativePopupChoice:" + (root.dataset.productId || "unknown"),
        JSON.stringify(payload)
      );
    } catch (error) {
      // Tracking event still fires when storage is unavailable.
    }

    return payload;
  }

  function openDialog(root, trigger, method) {
    if (!root) return;

    var dialog = root.querySelector("[data-ml-alt-dialog]");
    if (!dialog || dialog.open) return;

    if (trigger) {
      lastTriggerByDialog.set(dialog, trigger);
    }

    dialog.dataset.closeMethod = "";

    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }

    document.documentElement.classList.add("ml-alt-popup-open");

    pushDataLayer("alternative_popup_view", root, {
      open_method: method || "manual",
    });

    window.setTimeout(function () {
      var closeButton = dialog.querySelector("[data-ml-alt-close]");
      if (closeButton) closeButton.focus();
    }, 30);
  }

  function closeDialog(root, method) {
    if (!root) return;

    var dialog = root.querySelector("[data-ml-alt-dialog]");
    if (!dialog || !dialog.open) return;

    dialog.dataset.closeMethod = method || "close";

    if (typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
      handleDialogClosed(dialog);
    }
  }

  function handleDialogClosed(dialog) {
    var root = dialog.closest("[data-ml-alt-popup-root]");
    document.documentElement.classList.remove("ml-alt-popup-open");

    if (root) {
      pushDataLayer("alternative_popup_close", root, {
        close_method: dialog.dataset.closeMethod || "close",
      });
    }

    var lastTrigger = lastTriggerByDialog.get(dialog);
    if (lastTrigger && document.contains(lastTrigger)) {
      window.setTimeout(function () {
        lastTrigger.focus();
      }, 20);
    }
  }

  function toggleComparison(root, toggle) {
    var comparison = root.querySelector("[data-ml-alt-comparison]");
    if (!comparison) return;

    var isOpen = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!isOpen));
    comparison.hidden = isOpen;

    if (!isOpen) {
      pushDataLayer("alternative_compare_open", root);
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.mlAltInitialized === "true") return;
    root.dataset.mlAltInitialized = "true";

    var dialog = root.querySelector("[data-ml-alt-dialog]");
    if (!dialog) return;

    dialog.addEventListener("close", function () {
      handleDialogClosed(dialog);
    });

    dialog.addEventListener("cancel", function () {
      dialog.dataset.closeMethod = "escape";
    });

    var autoOpen = root.dataset.autoOpen === "true";
    var designMode = Boolean(window.Shopify && window.Shopify.designMode);

if (autoOpen && !designMode) {
  var delay = Number(root.dataset.openDelay || 0);

  window.setTimeout(function () {
    if (!document.contains(root)) return;

    openDialog(root, null, "auto");
  }, Math.max(0, delay));
}
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches("[data-ml-alt-popup-root]")) {
      initRoot(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll("[data-ml-alt-popup-root]").forEach(initRoot);
    }
  }

  document.addEventListener("click", function (event) {
    var openTrigger = event.target.closest("[data-ml-alt-open]");
    if (openTrigger) {
      event.preventDefault();
      openDialog(
        openTrigger.closest("[data-ml-alt-popup-root]"),
        openTrigger,
        "manual"
      );
      return;
    }

    var closeTrigger = event.target.closest("[data-ml-alt-close]");
    if (closeTrigger) {
      event.preventDefault();
      closeDialog(closeTrigger.closest("[data-ml-alt-popup-root]"), "button");
      return;
    }

    var compareToggle = event.target.closest("[data-ml-alt-compare-toggle]");
    if (compareToggle) {
      event.preventDefault();
      toggleComparison(
        compareToggle.closest("[data-ml-alt-popup-root]"),
        compareToggle
      );
      return;
    }

    var optionLink = event.target.closest("[data-ml-alt-option-link]");
    if (optionLink) {
      var root = optionLink.closest("[data-ml-alt-popup-root]");
      if (!root) return;

      var choice = rememberChoice(root, optionLink);
      pushDataLayer("alternative_option_click", root, choice);
    }
  });

  document.addEventListener("click", function (event) {
    var dialog = event.target.closest("[data-ml-alt-dialog]");
    if (!dialog || event.target !== dialog || !dialog.open) return;

    var panel = dialog.querySelector(".ml-alt-popup__panel");
    if (!panel) {
      closeDialog(dialog.closest("[data-ml-alt-popup-root]"), "backdrop");
      return;
    }

    var rect = panel.getBoundingClientRect();
    var outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;

    if (outside) {
      closeDialog(dialog.closest("[data-ml-alt-popup-root]"), "backdrop");
    }
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    var root = event.target.matches && event.target.matches("[data-ml-alt-popup-root]")
      ? event.target
      : event.target.querySelector && event.target.querySelector("[data-ml-alt-popup-root]");

    if (root) {
      initRoot(root);
      openDialog(root, null, "theme_editor");
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
